<template>
    <b-row
        v-if="$route.meta.breadcrumb || $route.meta.pageTitle"
        class="content-header"
    >

        <!-- Content Left -->
        <b-col
            class="content-header-left mb-2"
            cols="12"
            md="12"
        >
            <b-row class="breadcrumbs-top">
                <b-col cols="12">
                    <h2 class="float-left pr-1 mb-0">
                        {{ $route.meta.pageTitle }}
                    </h2>
                    <div v-if="$route.meta.subAction && !internalUser">
                        <component :is="$route.meta.subAction.component"/>
                    </div>
                </b-col>
            </b-row>
        </b-col>
    </b-row>
</template>

<script>
import {
    BRow, BCol
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import useSelectProjectAndGroup from '@/composables/useSelectProjectAndGroup'
const AppBreadCrumbSubActionBadge = () => import('./AppBreadCrumbSubActionBadge.vue')
export default {
    directives: {
        Ripple
    },
    components: {
        BRow,
        BCol,
        AppBreadCrumbSubActionBadge
    },
    setup () {
        const { internalUser } = useSelectProjectAndGroup()
        return {
            internalUser
        }
    }
}
</script>
